/**
 * Mini-cart drawer open state: toggles html.is-mini-cart-open for floating UI layering
 * (back-to-top, Seel AI Support #seel-ai-support host). Cart drawer z-index is 1200 (sz-2607-header).
 */
(function () {
  var MINI_CART_OPEN_CLASS = 'is-mini-cart-open';
  var MINI_CART_ID = 'mini-cart';
  var SEEL_HOST_ID = 'seel-ai-support';
  var UNDER_CART_Z_INDEX = '100';

  function isMiniCartOpen() {
    var drawer = document.getElementById(MINI_CART_ID);
    return !!(drawer && drawer.hasAttribute('open'));
  }

  function getSeelHost() {
    return document.getElementById(SEEL_HOST_ID);
  }

  function syncSeelWidgetLayer(underCart) {
    var el = getSeelHost();
    if (!el) return;
    if (underCart) {
      el.style.setProperty('z-index', UNDER_CART_Z_INDEX, 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('opacity', '0', 'important');
      el.style.pointerEvents = 'none';
    } else {
      el.style.removeProperty('z-index');
      el.style.removeProperty('visibility');
      el.style.removeProperty('opacity');
      el.style.pointerEvents = '';
    }
  }

  function syncMiniCartOpenClass() {
    var open = isMiniCartOpen();
    document.documentElement.classList.toggle(MINI_CART_OPEN_CLASS, open);
    syncSeelWidgetLayer(open);
  }

  document.addEventListener('openable-element:open', function (e) {
    if (e.target && e.target.id === MINI_CART_ID) syncMiniCartOpenClass();
  });

  document.addEventListener('openable-element:close', function (e) {
    if (e.target && e.target.id === MINI_CART_ID) syncMiniCartOpenClass();
  });

  function watchMiniCartAttribute() {
    var drawer = document.getElementById(MINI_CART_ID);
    if (!drawer || typeof MutationObserver === 'undefined') return;
    new MutationObserver(syncMiniCartOpenClass).observe(drawer, {
      attributes: true,
      attributeFilter: ['open']
    });
  }

  function watchSeelHostInjection() {
    if (typeof MutationObserver === 'undefined' || !document.body) return;
    new MutationObserver(function (mutations) {
      if (!document.documentElement.classList.contains(MINI_CART_OPEN_CLASS)) return;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.id === SEEL_HOST_ID || (node.querySelector && node.querySelector('#' + SEEL_HOST_ID))) {
            syncSeelWidgetLayer(true);
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  function boot() {
    syncMiniCartOpenClass();
    watchMiniCartAttribute();
    watchSeelHostInjection();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();